import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Tooltip from '@material-ui/core/Tooltip';
import PropTypes from 'prop-types';
import React from 'react';

const rows = [
  { id: 'resolucionDian', numeric: true, disablePadding: true, label: 'Resolución' },
  { id: 'dsPrefijo', numeric: true, disablePadding: true, label: 'Prefijo' },
  { id: 'nmInicio', numeric: true, disablePadding: true, label: 'Número inicial' },
  { id: 'nmFin', numeric: true, disablePadding: false, label: 'Número final' },
  { id: 'feExpedicion', numeric: true, disablePadding: false, label: 'Fecha expedición' },
  { id: 'feVencimiento', numeric: true, disablePadding: false, label: 'Fecha vencimiento' },
  { id: 'resultado', numeric: true, disablePadding: false, label: 'Resultado' },
];

class TablaEncabezado extends React.Component {
  createSortHandler = property => event => {
    this.props.onRequestSort(event, property);
  };

  render() {
    const {order, orderBy} = this.props;

    return (
      <TableHead>
        <TableRow>      
          {rows.map(
            row => (
              <TableCell
                key={row.id}
                align={row.numeric ? 'center' : 'center'}
                padding={row.disablePadding ? 'none' : 'default'}
                sortDirection={orderBy === row.id ? order : false}
              >
                <Tooltip
                  title="Ordenar"
                  placement={row.numeric ? 'bottom-end' : 'bottom-start'}
                  enterDelay={300}
                >
                  <TableSortLabel
                    active={orderBy === row.id}
                    direction={order}
                    onClick={this.createSortHandler(row.id)}
                  >
                    <h6>{row.label}</h6>
                  </TableSortLabel>
                </Tooltip>
              </TableCell>
            ),
            this,
          )}
        </TableRow>
      </TableHead>
    );
  }
}

TablaEncabezado.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

export default TablaEncabezado;